import ImageComponent from "./Image";
import { STATE } from "../../classes/Enum";

const CartImageComponent = ({item}) => {
    let imageSrc;
    if (STATE.CARD === item.type) {
        imageSrc=`/imgs/${item.setId}-low.png`;
    }
    else {
        imageSrc=`/products/${item.name}.PNG`;
    }

    return <div className="cart-image">
        <ImageComponent imageSrc={imageSrc} />
    </div>
}

export default CartImageComponent